export default __webpack_public_path__ + "static/media/home-bg.d9b0eebf.png";